import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './DeleteProject.css';

export const DeleteProject = ({ open, setOpenPopup, project, handleDiscardProject }) => {
  const { project_name } = project

  return (
    <React.Fragment>
      <Modal
        isOpen={open}
        toggle={() => setOpenPopup(!open)}
        centered
        className="modal-ml dashboard__content--project-actions-discard--confirm"
      >
        <ModalBody>
          <div className="close-modal" onClick={() => setOpenPopup(!open)}>
            <i className="icon icon-close_1 text-gray-light t-14"/>
          </div>
          <div className="title">
            <span className="t-18">
              Delete this project?
            </span>
          </div>
          <div className="info-message">
            <p className="text-gray-light t-16 mt-3">
              You will lose all project materials. We can’t recover them after you delete.
            </p>
          </div>
          <button className="cancel" onClick={() => setOpenPopup(!open)}> Cancel </button>
          <button
            className="delete ml-4"
            onClick={ () => {
              handleDiscardProject(project);
              setOpenPopup(!open);
            }}
          >
            Yes, Delete
          </button>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

DeleteProject.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpenPopup: PropTypes.func.isRequired,
  project: PropTypes.shape({}).isRequired,
  handleDiscardProject: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DeleteProject/DeleteProject.js